export default __webpack_public_path__ + "static/media/2021_08_02.2e573f2a.pdf";